import { takeLatest, put } from "redux-saga/effects";

import { REBOOK_FETCH_DATA_REQUEST } from "./constants";
import { rebookSuccess, rebookFailure } from "./actions";
import * as Api from '../../../services';
import _ from 'lodash';

function* dataReBooks() {
  try {
    const response = yield Api.getDataReBook();
    if (response.data.isSuccess) {

      const { data } = response.data;
      const bookingNumber = data.reservationNumber;
      const dataRegisterRoom = {
        lockVersion: data.lockVersion,
        reservationName: data.reservationName,
        reservationNameKana: data.reservationNameKana,
        billAddress: _.get(data, 'workOption.billAddress'),
        billToName: _.get(data, 'workOption.billToName'),
        billToNameKana: _.get(data, 'workOption.billNameKana'),
        billPostNumber: _.get(data, 'workOption.billPostNumber'),
        billToTelephoneNumber: _.get(data, 'workOption.billToTelephoneNumber'),
        email: data.email,
        phoneNumber: data.phoneNumber,
        room: data.roomId,
        roomNumber: data.room,
        options: _.get(data, 'workOption.options', []).map(i => ({
          ...i,
          checked: true,
        }))
      }

      const slotTimeId = {
        HasSlot: data.reservationAmPm,
        ReservationDateId: data.reservationDateId,
        conman: data.remarks,
        date: data.reservationDate
      }
      localStorage.setItem('slotTimeId', JSON.stringify(slotTimeId));
      localStorage.setItem('_dataRegisterRoom', JSON.stringify(dataRegisterRoom));
      localStorage.setItem('_bookingNumber', bookingNumber);
      yield put(rebookSuccess(true))
    }
  } catch (e) {
    yield put(rebookFailure(false))
  }
}



export function* saga() {
  yield takeLatest(REBOOK_FETCH_DATA_REQUEST, dataReBooks);
}
